
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[resource]",
      function () {
        return require("private-next-pages/[resource]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[resource]"])
      });
    }
  